<template>
  <div @click="open">
    <slot></slot>
    <popup class="popup-select" v-model="isActive" :title="title">
      <div>
        <slot name="custom" v-if="custom"></slot>
      </div>
      <ul v-if="!custom" class="list">
        <li
          class="list-item"
          :class="{ selected: realValue === op[valueField] }"
          v-for="op of options"
          :key="index"
          @click="select(op)"
        >
          {{ op[descField] }}
        </li>
      </ul>
    </popup>
  </div>
</template>
<script>
import Popup from './Popup'
export default {
  components: {
    Popup
  },
  props: {
    //是否需要自定义列表
    custom: {
      type: Boolean,
      default: function () {
        return false;
      }
    },
    options: {
      type: Array
    },
    title: {
      type: String
    },
    valueField: {
      type: String,
      default: function () {
        return 'key'
      }
    },
    descField: {
      type: String,
      default: function () {
        return 'name'
      }
    },
    value: {
      type: [Object, String]
    },
    //强制选择
    forced: {
      type: Boolean,
      default: function () {
        return false
      }
    },
    disabled: {
      type: Boolean
    }
  },
  computed: {
    realValue () {
      const value = this.value
      const valueField = this.valueField;
      return typeof value === 'object' ? value[valueField] : value;
    }
  },
  methods: {
    open () {
      this.isActive = !this.disabled;
    },
    // close() {
    //     this.isActive = false;
    // },
    select (option) {
      if (typeof this.value === 'string') {
        this.$emit('input', option[this.valueField]);
      } else {
        this.$emit('input', option);
      }
      this.$emit('selected', option);
    }
  },
  data () {
    return {
      isActive: !!this.forced
    }
  }
}
</script>
<style lang="scss">
@import "../../static/sass/_variable.scss";
.popup-select {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  overflow-y: auto;
  z-index: 1000;
  text-align: left;
  color: #444;
  z-index: 4;
  list-style: none;
  background-color: #fff;
  li {
    //有些在header中会继承header18的字体
    font-size: 0.35rem;
    line-height: 2;
  }
}
</style>


// WEBPACK FOOTER //
// PopupSelect.vue?04349b38